<template>
  <div class="">
    <v-card class="pa-6">
      <v-card-title class="mb-5">
        CSR Sales Report
      </v-card-title>
      <v-card-title>
        <v-icon
          class="mr-2"
        >
          mdi-filter-outline
        </v-icon> Filter
      </v-card-title>
      <v-card-text>
        <v-row class="pa-0">
          <v-col cols="12" md="3">
            <v-select
              v-model="agent"
              :items="agents"
              menu-props="auto"
              label="Sales Agent"
              item-text="name"
              item-value="id"
              hide-details
            >
            <template v-slot:item="{ item }">
                <v-divider class="mb-2"></v-divider>
                <v-list-item disabled>
                  <v-list-item-avatar color="grey lighten-3">
                    <v-icon>
                      mdi-face-agent
                    </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title class="text--primary">
                      {{ item.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ item.code }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              v-model="menuMonth"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Month"
                  append-icon="mdi-calendar"
                  readonly
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                type="month"
                @input="menuMonth = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mx-2"
                fab
                depressed
                color="primary"
                v-on="on"
                @click="doPrint()"
              >
                <v-icon dark>
                  mdi-printer
                </v-icon>
              </v-btn>
            </template>
            <span>Print</span>
          </v-tooltip>
        </v-row>
        <!-- <v-row class="pa-0">
          <v-radio-group
            v-model="row"
            row
            class="pl-3"
          >
            <template v-slot:label>
              <div>By</div>
            </template>
            <v-radio
              label="Month"
              value="month"
            ></v-radio>
            <v-radio
              label="Year"
              value="year"
            ></v-radio>
          </v-radio-group>
        </v-row> -->
        <!-- <v-row class="pa-0">
          <v-col cols="12" md="3">
            <v-menu
              v-model="menuMonth"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="month"
                  label="Month"
                  append-icon="mdi-calendar"
                  readonly
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="month"
                type="month"
                @input="menuMonth = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row> -->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import printJS from 'print-js'

  export default {
    name: 'RptCsrSales',
    data() {
      return {
        agents: [],
        agent: '',
        menuMonth: false,
        date: new Date().toISOString().substr(0, 7),
      }
    },
    computed: {
      ...mapGetters(['formatNumberAmount', 'formatNumber', 'getApiUrl'])
    },
    watch: {
    },
    methods: {
      getAgents () {
        let self = this
        this.$http.plain.get('/default-data?agents=true')
          .then(response => {
            response.data.agents.forEach(obj => {
              this.agents.push({ id: obj.id, code: obj.code, name: obj.first_name + ' ' + obj.last_name })
            })

            this.agents.unshift({ id: '', code: '', name: 'All' })
          })
          .catch(error => {
            console.log(error);
          })
      },
      doPrint () {
        const currentDate = new Date();
        const unixTimestamp = Math.floor(currentDate.getTime() / 1000)

        let params = []
        params.push('date'+'='+this.date)
        params.push('v'+'='+unixTimestamp)
        if (this.agent !== '') params.push('agent'+'='+this.agent)
        window.open(this.getApiUrl+'/api/reports/csr-sales?'+params.join('&'), '_newtab');
      },
    },
    mounted() {
      this.getAgents()
    },
    components: {
    },
  }
</script>
